/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;height:calc(100vh - 50px);overflow:hidden}@media (min-width:768px){[_nghost-%COMP%]{margin-bottom:-70px}}"];
export { styles as styles };
